var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dollar Sign in Circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,0.1C10.8,0.1,0.1,10.8,0.1,24S10.8,47.9,24,47.9S47.9,37.2,47.9,24S37.2,0.1,24,0.1 M24,45.9   C11.9,45.9,2.1,36.1,2.1,24S11.9,2.1,24,2.1S45.9,11.9,45.9,24S36.1,45.9,24,45.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.9 22.4l1.3-10.6c1.4 0.3 2.7 1 3.7 1.5l1-1.7c-1.2-0.7-2.7-1.4-4.5-1.8l0.4-3.6-2-0.2-0.4 3.6h-0.1c-3.9 0-7.6 3.2-7.6 6.5 0 3 2 5.5 6.1 7.4l-1.4 11.6c-1.7-0.3-2.9-1-4-1.6l-0.2-0.1-1 1.7 0.2 0.1c1.2 0.7 2.7 1.5 4.8 1.9l-0.4 3.5 2 0.2 0.4-3.6h0.1c4.3 0 8.7-2.6 8.7-7 0-3.5-1.9-5.6-7.1-7.8m-6.2-6.2c0-2.2 2.7-4.5 5.4-4.5l-1.1 9.8c-2.9-1.5-4.3-3.2-4.3-5.3m4.7 19.1l1.3-10.8c4.4 2 5.2 3.5 5.2 5.8 0 3.4-3.8 5-6.5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.d74861bdb1d65f26bad4357d975c31dc.svg";
export { ForwardRef as ReactComponent };